module.exports = __webpack_public_path__ + "assets/img/icon2-menu2.43d119b4.svg";